import {
  Box,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useAppSelector } from "store/appHooks";

const stepsTillDelivered = [
  {
    label: "Booking Request",
    description: "Your booking request has been raised successfully.",
    status: 1,
  },
  {
    label: "Pending Approval",
    description: "Your booking approval is pending by owner",
    status: 1,
  },
  {
    label: "Ready for delivery",
    description: "Your item has been ready delivery .",
    status: 2,
  },
  {
    label: "Delivered",
    description: "Your item has been delivered .",
    status: 4,
  },
];

const stepsAfterDelivered = [
  {
    label: "Return Request Initiated",
    description: "Your return request has been initiated successfully.",
    status: 7,
  },
  {
    label: "Item Pickup ",
    description: "Your item has been picked by delivery partner.",
    status: 7,
  },
  {
    label: "Return Successfully",
    description: "Your item has been return successfully.",
    status: 7,
  },
];

const beforeDeliveryStatusMap: any = {
  1: 0,
  2: 1,
  3: 2,
  9: 4,
  7: 3,
};
const BookingCompletionStage = () => {
  const { personalRentalReducer } = useAppSelector((state) => state);
  const { details }: any = personalRentalReducer;
  const lastBookingStatus = details?.booking_status;
  // details?.booking_updates?.[details?.booking_updates.length - 1]
  //   ?.booking_status ?? 0;
  const activeStep = beforeDeliveryStatusMap[lastBookingStatus];

  const getBookingUpdateTime = (st: number) => {
    const targetedIndex = st;
    const filter = details?.booking_updates?.find(
      (r: any) => r.booking_status === targetedIndex
    );

    return filter || null;
  };

  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "30px",
          color: "#2A2A2A",
        }}
      >
        Tracking Status
      </Typography>
      <Box sx={{ my: "20px" }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {([1, 2, 3, 9].includes(details?.booking_status)
            ? stepsTillDelivered
            : stepsAfterDelivered
          ).map((step: any) => (
            <Step expanded={true}>
              <StepLabel sx={{ p: 0 }}>
                <Typography
                  sx={{
                    color: "#323232",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "21px",
                  }}
                >
                  {step.label}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography
                  sx={{
                    color: "#A2A2A2",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  {getBookingUpdateTime(step.status)
                    ? getBookingUpdateTime(step.status).description
                    : step.description}
                </Typography>
                <Typography
                  sx={{
                    color: "#A2A2A2",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                    marginTop: getBookingUpdateTime(step.status) ? "10px" : "",
                  }}
                >
                  {getBookingUpdateTime(step.status)?.created_at
                    ? moment(
                        getBookingUpdateTime(step.status)?.created_at
                      ).format("MMM DD, yyyy hh:mm A")
                    : ""}
                </Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default BookingCompletionStage;
